import React from "react";

export default function EditTechpack() {
  return (
    <div>
      <h2>Edit Item </h2>
    </div>
  );
}
